var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
    onClick: function () { },
};
var BackIcon = function BackIcon(props) {
    var onClick = props.onClick;
    return (_jsx("svg", __assign({ width: "25px", height: "25px", viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg", onClick: onClick, className: "c-pointer back-icon-svg", id: "main-app-back-btn-am" }, { children: _jsx("g", __assign({ id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: _jsx("g", __assign({ id: "Alert-Filter", transform: "translate(-970.000000, -92.000000)" }, { children: _jsx("g", __assign({ id: "Group-25", transform: "translate(886.000000, 0.000000)" }, { children: _jsxs("g", __assign({ id: "Group-20", transform: "translate(84.000000, 92.000000)" }, { children: [_jsx("circle", { id: "Oval", fill: "#424B50", cx: "14", cy: "14", r: "14" }), _jsx("polygon", { id: "Path", fill: "#FFFFFF", fillRule: "nonzero", transform: "translate(13.000000, 14.000000) rotate(-270.000000) translate(-13.000000, -14.000000) ", points: "7 12.1358025 9.17263158 10 13 13.7407407 16.8273684 10 19 12.1358025 13 18" })] })) })) })) })) })));
};
BackIcon.defaultProps = defaultProps;
export default BackIcon;
